import {ContractVariant} from '@enums'

import {atom} from 'jotai'

import {initialDropdownOptions, initialSetupData} from './initial-data'
import {ContractFormDropdownOptions, LookupMapType, SetupData} from './types'

export const contractResourcesAtom = atom<SetupData>(initialSetupData)

export const lookupContractResourcesAtom = atom<LookupMapType>(get => {
  const setupData = get(contractResourcesAtom)

  return value => ({
    company: setupData.companies.find(item => item.id === value),
    dealer: setupData.dealers.find(item => item.id === value),
    contractType: setupData.contractTypes.find(item => item.id === value),
    type: value as ContractVariant,
    deliveryDate: value,
    length: value,
  })
})

export const contractDropdownOptionsAtom = atom<ContractFormDropdownOptions>(initialDropdownOptions)
